import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import { CSVLink } from "react-csv";

const url = "https://api.mrcirp.com/public/leads";
const urldelete = "https://api.mrcirp.com/public/usuariosdelete";
const urleditar = "https://api.mrcirp.com/public/usuariosedit";

const Leads = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    usuario: "",
    descripcion: "",
    urlvideo: "",
    urlVideoProducto1: "",
    urlVideoProducto2: "",
    urlVideoProducto3: "",
    urlNegocio1: "",
    urlNegocio2: "",
    urlNegocio3: "",
    urlComoUnirseCliente: "",
    urlComoAfiliarse: "",
    fecha: "",
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Nombre",
      selector: (row) => row.nombre,
    },
    {
      name: "Descripcion",
      selector: (row) => row.correo,
    },
    {
      name: "telefono",
      selector: (row) => row.telefono,
    },
    {
      name: "Campaña",
      selector: (row) => row.usuario,
    },
    {
      name: "Fecha",
      selector: (row) => row.fecha,
    },
  ];

  /////////////Buscar datos//////////////////////////////////
  const [tipoBusqueda, setTipoBusqueda] = useState("general"); // "general", "campana", "codigo_pais", "fechas"
  const [buscar, setBuscar] = useState("");
  const [buscarCampana, setBuscarCampana] = useState("");
  const [buscarCodigoPais, setBuscarCodigoPais] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    let result = data;

    // Aplicar filtros según el tipo de búsqueda seleccionado
    if (tipoBusqueda === "campana") {
      if (buscarCampana) {
        result = result.filter((resultdata) => {
          if (resultdata.usuario && resultdata.usuario.toLowerCase().match(buscarCampana.toLowerCase())) {
            return resultdata;
          }
          return false;
        });
      }
      // Si no hay texto de búsqueda, mostrar todos
    } else if (tipoBusqueda === "codigo_pais") {
      if (buscarCodigoPais) {
        result = result.filter((resultdata) => {
          if (resultdata.telefono) {
            // Buscar el código de país al inicio del teléfono (formato +51, +1, etc.)
            const telefonoStr = resultdata.telefono.toString();
            // Buscar si el teléfono comienza con el código de país buscado
            if (telefonoStr.startsWith(buscarCodigoPais) || telefonoStr.includes(buscarCodigoPais)) {
              return resultdata;
            }
          }
          return false;
        });
      }
      // Si no hay código de país, mostrar todos
    } else if (tipoBusqueda === "fechas") {
      // Si no hay filtros de fecha, mostrar todos
      if (!fechaInicio && !fechaFin) {
        result = data;
      } else {
        result = result.filter((resultdata) => {
          if (resultdata.fecha) {
            try {
              const fechaLead = new Date(resultdata.fecha);
              
              // Validar que la fecha sea válida
              if (isNaN(fechaLead.getTime())) {
                return false;
              }
              
              // Si solo hay fecha de inicio
              if (fechaInicio && !fechaFin) {
                const inicio = new Date(fechaInicio);
                inicio.setHours(0, 0, 0, 0);
                fechaLead.setHours(0, 0, 0, 0);
                return fechaLead >= inicio;
              }
              // Si solo hay fecha de fin
              else if (!fechaInicio && fechaFin) {
                const fin = new Date(fechaFin);
                fin.setHours(23, 59, 59, 999);
                fechaLead.setHours(23, 59, 59, 999);
                return fechaLead <= fin;
              }
              // Si hay ambas fechas
              else if (fechaInicio && fechaFin) {
                const inicio = new Date(fechaInicio);
                const fin = new Date(fechaFin);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(23, 59, 59, 999);
                fechaLead.setHours(0, 0, 0, 0);
                return fechaLead >= inicio && fechaLead <= fin;
              }
              
              return false;
            } catch (error) {
              console.error("Error al procesar fecha:", error, resultdata.fecha);
              return false;
            }
          }
          return false;
        });
      }
    } else {
      // Búsqueda general (comportamiento original)
      if (buscar) {
        result = result.filter((resultdata) => {
          if (
            (resultdata.nombre && resultdata.nombre.toLowerCase().match(buscar.toLowerCase())) ||
            (resultdata.correo && resultdata.correo.toLowerCase().match(buscar.toLowerCase())) ||
            (resultdata.usuario && resultdata.usuario.toLowerCase().match(buscar.toLowerCase()))
      ) {
        return resultdata;
      }
          return false;
    });
      }
    }

    setFiltroBuscar(result);
  }, [buscar, buscarCampana, buscarCodigoPais, fechaInicio, fechaFin, tipoBusqueda, data]);

  // Limpiar filtros cuando cambia el tipo de búsqueda
  useEffect(() => {
    setBuscar("");
    setBuscarCampana("");
    setBuscarCodigoPais("");
    setFechaInicio("");
    setFechaFin("");
  }, [tipoBusqueda]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    // eslint-disable-next-line no-template-curly-in-string
    await axios
      .delete(urldelete + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditar(false);
      })
      .catch((err) => {
        setError(true);
        setModalEditar(false);
      });
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(urleditar + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    await axios.get(url + "/" + users.id).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
      console.log(data);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (users.id) {
      await peticionGet();
    }
  }, [users.id]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-12">Leads captados</div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title> Leads registrado</Card.Title>
                  {Error && (
                    <div className="alert alert-danger">
                      {
                        <strong>
                          Error: El nombre ya existe! intente con otro nombre.
                        </strong>
                      }
                    </div>
                  )}
                  <p> Leads registrado en el sistema.</p>
                  <div className="d-flex mb-3 align-items-center">
                    <CSVLink
                      data={filtrobuscar}
                      filename={(() => {
                        const fecha = new Date().toISOString().split('T')[0];
                        let nombreArchivo = `leads_${fecha}`;
                        
                        if (tipoBusqueda === "campana" && buscarCampana) {
                          nombreArchivo += `_campaña_${buscarCampana.replace(/\s+/g, '_')}`;
                        } else if (tipoBusqueda === "codigo_pais" && buscarCodigoPais) {
                          nombreArchivo += `_codigo_${buscarCodigoPais.replace(/\+/g, '')}`;
                        } else if (tipoBusqueda === "fechas" && (fechaInicio || fechaFin)) {
                          if (fechaInicio && fechaFin) {
                            nombreArchivo += `_${fechaInicio}_${fechaFin}`;
                          } else if (fechaInicio) {
                            nombreArchivo += `_desde_${fechaInicio}`;
                          } else if (fechaFin) {
                            nombreArchivo += `_hasta_${fechaFin}`;
                          }
                        } else if (tipoBusqueda === "general" && buscar) {
                          nombreArchivo += `_busqueda_${buscar.replace(/\s+/g, '_').substring(0, 20)}`;
                        }
                        
                        return `${nombreArchivo}.csv`;
                      })()}
                      className="btn btn-primary me-2"
                      target="_blank"
                    >
                      Descargar CSV ({filtrobuscar.length} registros)
                    </CSVLink>
                    {filtrobuscar.length !== data.length && (
                      <span className="text-muted">
                        (Mostrando {filtrobuscar.length} de {data.length} leads)
                      </span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Tipo de búsqueda:</label>
                    <select
                      className="form-control mb-2"
                      style={{ maxWidth: "300px" }}
                      value={tipoBusqueda}
                      onChange={(e) => setTipoBusqueda(e.target.value)}
                    >
                      <option value="general">Búsqueda General</option>
                      <option value="campana">Por Campaña</option>
                      <option value="codigo_pais">Por Código de País</option>
                      <option value="fechas">Por Intervalo de Fechas</option>
                    </select>

                    {tipoBusqueda === "general" && (
                      <input
                        type="text"
                        placeholder="Buscar por Nombre, Correo o Campaña"
                        className="form-control"
                        style={{ maxWidth: "400px" }}
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    )}

                    {tipoBusqueda === "campana" && (
                      <input
                        type="text"
                        placeholder="Buscar por Campaña"
                        className="form-control"
                        style={{ maxWidth: "400px" }}
                        value={buscarCampana}
                        onChange={(e) => setBuscarCampana(e.target.value)}
                      />
                    )}

                    {tipoBusqueda === "codigo_pais" && (
                      <input
                        type="text"
                        placeholder="Buscar por Código de País (ej: +51, +1)"
                        className="form-control"
                        style={{ maxWidth: "400px" }}
                        value={buscarCodigoPais}
                        onChange={(e) => setBuscarCodigoPais(e.target.value)}
                      />
                    )}

                    {tipoBusqueda === "fechas" && (
                      <div className="row" style={{ maxWidth: "600px" }}>
                        <div className="col-md-6 mb-2">
                          <label className="form-label">Fecha:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-2">
                          <label className="form-label">Fecha:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                     noDataComponent="No hay leads"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                  />

                  <Modal isOpen={modalEditar}>
                    <ModalHeader>
                      <div>
                        <h4>Eliminar usuario </h4>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <input
                        className="form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="form-group">
                        <h5>
                          ¿Desea eliminar al usuario #{datosSeleccionados.id}?{" "}
                        </h5>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => peticionPut()}
                      >
                        Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser}>
                    <ModalHeader>
                      <div>
                        <h5>Editar usuario {datosSeleccionados.username}</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                        <input
                          className="form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label>Descripcion</label>
                        <textarea
                          className="form-control"
                          name="descripcion"
                          value={datosSeleccionados.descripcion}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlvideo"
                          value={datosSeleccionados.urlvideo}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 1</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto1"
                          value={datosSeleccionados.urlvideoproducto1}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 2</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto2"
                          value={datosSeleccionados.urlvideoproducto2}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 3</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto3"
                          value={datosSeleccionados.urlvideoproducto3}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 1</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio1"
                          value={datosSeleccionados.urlnegocio1}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 2</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio2"
                          value={datosSeleccionados.urlnegocio2}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 3</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio3"
                          value={datosSeleccionados.urlnegocio3}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL como unirse como cliente</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlComoUnirseCliente"
                          value={datosSeleccionados.urlcomounirsecliente}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL como afiliarse</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlComoAfiliarse"
                          value={datosSeleccionados.urlcomoafiliarse}
                          onChange={handleChange}
                        />
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => peticionPutuser()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Leads;